module.exports = __webpack_public_path__ + "img/icon_map_51_on_110.cf537acb.png";